export * from 'server/models/DefaultImage';


// WEBPACK FOOTER //
// ./data/models/DefaultImage.ts